import FieldsModel from '@/Models/Contracts/FieldsModel';
import i18n from '@/Plugins/i18n';
export default class Extrapolation extends FieldsModel {
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    constructor(...props) {
        super(...props);
        this.type = 'extrapolation';
    }
    getType() {
        return 'extrapolation';
    }
    get header() {
        return `
            <span class="grid gap-2">
                <span>${i18n.t('general.extrapolation')}</span>
                <span>${moment(this.date).format('D. MMMM YYYY')}</span>
            </span>
        `;
    }
}
